

module.exports = angular.module;


/*****************
 ** WEBPACK FOOTER
 ** ./components/squid/dist/module.js
 ** module id = 270
 ** module chunks = 1
 **/